
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
:host {
  display: block;
}

.uppercase{
  text-transform:uppercase;
}

:host([capital-style='uppercase']) {
  letter-spacing: 0.1em;
  text-transform:uppercase;
}

:host([capital-style='capitalize']) {
  text-transform: capitalize;
}

:host([capital-style='lowercase']) {
  text-transform: lowercase;
}

:host([capital-style='none']) {
  text-transform: none;
}

:host([capital-style='full-width']){
  text-transform:full-width;
}

:host([capital-style='full-size-kana']){
  text-transform:full-size-kana;
}

:host span, :host p, :host h1, :host h2, :host h3, :host h4, :host h5, :host h6 {
  font-family: Open Sans, Helvetica, Arial, sans-serif;
}

:host([margin-size='0px']) span, :host([margin-size='0px']) p, :host([margin-size='0px']) h1, :host([margin-size='0px']) h2, :host([margin-size='0px']) h3, :host([margin-size='0px']) h4, :host([margin-size='0px']) h5, :host([margin-size='0px']) h6 {
  margin: 0px;
}

:host([margin-size='4px']) span, :host([margin-size='4px']) p, :host([margin-size='4px']) h1, :host([margin-size='4px']) h2, :host([margin-size='4px']) h3, :host([margin-size='4px']) h4, :host([margin-size='4px']) h5, :host([margin-size='4px']) h6 {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}

:host([margin-size='8px']) span, :host([margin-size='8px']) p, :host([margin-size='8px']) h1, :host([margin-size='8px']) h2, :host([margin-size='8px']) h3, :host([margin-size='8px']) h4, :host([margin-size='8px']) h5, :host([margin-size='8px']) h6 {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}

:host([margin-size='12px']) span, :host([margin-size='12px']) p, :host([margin-size='12px']) h1, :host([margin-size='12px']) h2, :host([margin-size='12px']) h3, :host([margin-size='12px']) h4, :host([margin-size='12px']) h5, :host([margin-size='12px']) h6 {
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}

:host([margin-size='20px']) span, :host([margin-size='20px']) p, :host([margin-size='20px']) h1, :host([margin-size='20px']) h2, :host([margin-size='20px']) h3, :host([margin-size='20px']) h4, :host([margin-size='20px']) h5, :host([margin-size='20px']) h6 {
  margin-top: 1.25rem;
  margin-bottom: 1.25rem;
}

:host([margin-size='24px']) span, :host([margin-size='24px']) p, :host([margin-size='24px']) h1, :host([margin-size='24px']) h2, :host([margin-size='24px']) h3, :host([margin-size='24px']) h4, :host([margin-size='24px']) h5, :host([margin-size='24px']) h6 {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}

:host([margin-size='31px']) span, :host([margin-size='31px']) p, :host([margin-size='31px']) h1, :host([margin-size='31px']) h2, :host([margin-size='31px']) h3, :host([margin-size='31px']) h4, :host([margin-size='31px']) h5, :host([margin-size='31px']) h6 {
  margin-top: 31px;
  margin-bottom: 31px;
}

:host([margin-size='56px']) span, :host([margin-size='56px']) p, :host([margin-size='56px']) h1, :host([margin-size='56px']) h2, :host([margin-size='56px']) h3, :host([margin-size='56px']) h4, :host([margin-size='56px']) h5, :host([margin-size='56px']) h6 {
  margin-top: 3.5rem;
  margin-bottom: 3.5rem;
}

.style-override--search-results-eyebrow{
  -webkit-margin-before:20px;
          margin-block-start:20px;
  -webkit-margin-after:0px;
          margin-block-end:0px;
}

.style-override--search-results-title{
  -webkit-margin-before:0px;
          margin-block-start:0px;
}

.idb-text--base {
  font-size: var(--fs-base) !important;
  line-height: var(--lh-base) !important;
}

@media (min-width: 1280px) {

  .idb-text--base {
    font-size: var(--fs-sm) !important;
    line-height: var(--lh-sm) !important;
  }
}

@media (min-width: 1440px) {

  .idb-text--base {
    font-size: var(--fs-base) !important;
    line-height: var(--lh-base) !important;
  }
}

.idb-text--xs {
  font-size: var(--fs-xs) !important;
  line-height: var(--lh-xs) !important;
}

.idb-text--sm {
  font-size: var(--fs-sm) !important;
  line-height: var(--lh-sm) !important;
}

@media (min-width: 1280px) {

  .idb-text--sm {
    font-size: var(--fs-xs) !important;
    line-height: var(--lh-xs) !important;
  }
}

@media (min-width: 1440px) {

  .idb-text--sm {
    font-size: var(--fs-sm) !important;
    line-height: var(--lh-sm) !important;
  }
}

.idb-text--lg {
  font-size: var(--fs-lg) !important;
  line-height: var(--lh-lg) !important;
}

@media (min-width: 1280px) {

  .idb-text--lg {
    font-size: var(--fs-sm) !important;
    line-height: var(--lh-sm) !important;
  }
}

@media (min-width: 1440px) {

  .idb-text--lg {
    font-size: var(--fs-lg) !important;
    line-height: var(--lh-lg) !important;
  }
}

.idb-text--lg.mobile {
  font-size: var(--fs-lg) !important;
  line-height: var(--lh-lg) !important;
}

.idb-text--xl {
  font-size: var(--fs-xl) !important;
  line-height: var(--lh-xl) !important;
}

@media (min-width: 1280px) {

  .idb-text--xl {
    font-size: var(--fs-lg) !important;
    line-height: var(--lh-lg) !important;
  }
}

@media (min-width: 1440px) {

  .idb-text--xl {
    font-size: var(--fs-xl) !important;
    line-height: var(--lh-xl) !important;
  }
}

.idb-text--xl.mobile {
  font-size: var(--fs-xl) !important;
  line-height: var(--lh-xl) !important;
}

.idb-text--2xl {
  font-size: var(--fs-2xl) !important;
  line-height: var(--lh-2xl) !important;
}

@media (min-width: 1280px) {

  .idb-text--2xl {
    font-size: var(--fs-lg) !important;
    line-height: var(--lh-lg) !important;
  }
}

@media (min-width: 1440px) {

  .idb-text--2xl {
    font-size: var(--fs-2xl) !important;
    line-height: var(--lh-2xl) !important;
  }
}

.idb-text--2xl.mobile {
  font-size: var(--fs-xl) !important;
  line-height: var(--lh-xl) !important;
}

.idb-text--3xl {
  font-size: var(--fs-3xl) !important;
  line-height: var(--lh-3xl) !important;
}

@media (min-width: 1280px) {

  .idb-text--3xl {
    font-size: var(--fs-2xl) !important;
    line-height: var(--lh-2xl) !important;
  }
}

@media (min-width: 1440px) {

  .idb-text--3xl {
    font-size: var(--fs-3xl) !important;
    line-height: var(--lh-3xl) !important;
  }
}

.idb-text--3xl.mobile {
  font-size: var(--fs-2xl) !important;
  line-height: var(--lh-2xl) !important;
}

.idb-text--4xl {
  font-size: var(--fs-4xl) !important;
  line-height: var(--lh-4xl) !important;
}

@media (min-width: 1280px) {

  .idb-text--4xl {
    font-size: var(--fs-3xl) !important;
    line-height: var(--lh-3xl) !important;
  }
}

@media (min-width: 1440px) {

  .idb-text--4xl {
    font-size: var(--fs-4xl) !important;
    line-height: var(--lh-4xl) !important;
  }
}

.idb-text--4xl.mobile {
  font-size: var(--fs-3xl) !important;
  line-height: var(--lh-3xl) !important;
}

.idb-text--h1-small {
  font-size: var(--fs-h1-small);
  line-height: var(--lh-h1-small);
}

@media (min-width: 1280px) {

  .idb-text--h1-small {
    font-size: var(--fs-h2-small);
    line-height: var(--lh-h2-small);
  }
}

@media (min-width: 1440px) {

  .idb-text--h1-small {
    font-size: var(--fs-h1-small);
    line-height: var(--lh-h1-small);
  }
}

.idb-text--h1-small.mobile {
  font-size: var(--fs-h2-small);
  line-height: var(--lh-h2-small);
}

.idb-text--5xl {
  font-size: var(--fs-5xl) !important;
  line-height: var(--lh-5xl) !important;
}

@media (min-width: 1280px) {

  .idb-text--5xl {
    font-size: var(--fs-4xl) !important;
    line-height: var(--lh-4xl) !important;
  }
}

@media (min-width: 1440px) {

  .idb-text--5xl {
    font-size: var(--fs-5xl) !important;
    line-height: var(--lh-5xl) !important;
  }
}

.idb-text--5xl.mobile {
  font-size: var(--fs-2xl) !important;
  line-height: var(--lh-2xl) !important;
}

.idb-text--6xl {
  font-size: var(--fs-6xl) !important;
  line-height: var(--lh-6xl) !important;
}

@media (min-width: 1280px) {

  .idb-text--6xl {
    font-size: var(--fs-5xl) !important;
    line-height: var(--lh-5xl) !important;
  }
}

@media (min-width: 1440px) {

  .idb-text--6xl {
    font-size: var(--fs-6xl) !important;
    line-height: var(--lh-6xl) !important;
  }
}

.idb-text--6xl.mobile {
  font-size: var(--fs-3xl) !important;
  line-height: var(--lh-3xl) !important;
}

.idb-text--7xl {
  font-size: var(--fs-7xl) !important;
  line-height: var(--lh-7xl) !important;
}

@media (min-width: 1280px) {

  .idb-text--7xl {
    font-size: var(--fs-6xl) !important;
    line-height: var(--lh-6xl) !important;
  }
}

@media (min-width: 1440px) {

  .idb-text--7xl {
    font-size: var(--fs-7xl) !important;
    line-height: var(--lh-7xl) !important;
  }
}

.idb-text--7xl.mobile {
  font-size: var(--fs-4xl) !important;
  line-height: var(--lh-4xl) !important;
}

.idb-text--8xl {
  font-size: var(--fs-8xl) !important;
  line-height: var(--lh-8xl) !important;
}

@media (min-width: 1280px) {

  .idb-text--8xl {
    font-size: var(--fs-8xl) !important;
    line-height: var(--lh-8xl) !important;
  }
}

@media (min-width: 1440px) {

  .idb-text--8xl {
    font-size: var(--fs-8xl) !important;
    line-height: var(--lh-8xl) !important;
  }
}

.idb-text--8xl.mobile {
  font-size: var(--fs-5xl) !important;
  line-height: var(--lh-5xl) !important;
}

.idb-text--9xl {
  font-size: var(--fs-9xl) !important;
  line-height: var(--lh-9lx) !important;
}

@media (min-width: 1280px) {

  .idb-text--9xl {
    font-size: var(--fs-9xl) !important;
    line-height: var(--lh-9lx) !important;
  }
}

@media (min-width: 1440px) {

  .idb-text--9xl {
    font-size: var(--fs-9xl) !important;
    line-height: var(--lh-9lx) !important;
  }
}

.idb-text--9xl.mobile {
  font-size: var(--fs-6xl) !important;
  line-height: var(--lh-6xl) !important;
}

.idb-font--thin {
  font-weight: var(--fw-extralight);
}

.idb-font--extralight {
  font-weight: var(--fw-thin);
}

.idb-font--light {
  font-weight: var(--fw-light);
}

.idb-font--normal {
  font-weight: var(--fw-normal);
}

.idb-font--medium {
  font-weight: var(--fw-medium);
}

.idb-font--semibold {
  font-weight: var(--fw-semibold);
}

.idb-font--bold {
  font-weight: var(--fw-bold);
}

.idb-font--extrabold {
  font-weight: var(--fw-extrabold);
}

.idb-font--black {
  font-weight: var(--fw-black);
}

.idb-color--blue {
  color: var(--blue-responsible-main);
}

.idb-color--blue-light {
  color: var(--blue-responsible-lighten-1);
}

.idb-color--blue-dark-1 {
  color: var(--blue-responsible-darken-1);
}

.idb-color--blue-dark-2 {
  color: var(--blue-responsible-darken-2);
}

.idb-color--gray {
  color: var(--gray-professional-main);
}

.idb-color--gray-light {
  color: var(--gray-professional-lighten-1);
}

.idb-color--gray-dark-1 {
  color: var(--gray-professional-darken-1);
}

.idb-color--gray-dark-2 {
  color: var(--gray-professional-darken-2);
}

.idb-color--cyan {
  color: var(--cyan-near-main);
}

.idb-color--cyan-light {
  color: var(--cyan-near-lighten-1);
}

.idb-color--cyan-dark-1 {
  color: var(--cyan-near-darken-1);
}

.idb-color--cyan-dark-2 {
  color: var(--cyan-near-darken-2);
}

.idb-color--white {
  color: var(--neutral-white);
}

.idb-width--default {
  width: 100%;
}

.idb-width--50 {
  width: 100%;
}

@media (min-width: 768px) {

  .idb-width--50 {
    width: 50%;
  }
}

.idb-width--60 {
  width: 100%;
}

@media (min-width: 768px) {

  .idb-width--60 {
    width: 60%;
  }
}

.idb-width--70 {
  width: 100%;
}

@media (min-width: 768px) {

  .idb-width--70 {
    width: 70%;
  }
}

.idb-width--80 {
  width: 100%;
}

@media (min-width: 768px) {

  .idb-width--80 {
    width: 80%;
  }
}

.idb-heading__wrapper {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.idb-heading__cta {
  font-size: var(--fs-base);
  line-height: var(--lh-base);
  -webkit-text-decoration-line: underline;
          text-decoration-line: underline;
}

.idb-heading__wrapper.idb-border--full {
  border-width: 1px;
}

.idb-heading__wrapper.idb-border--top {
  border-top-width: 1px;
}

.idb-heading__wrapper.idb-border--bottom {
  border-bottom-width: 1px;
}

.idb-heading__wrapper.idb-border-color--black {
  border-color: var(--neutral-black);
}

.idb-heading__wrapper.idb-border-color--white {
  border-color: var(--neutral-white);
}

.idb-heading__wrapper.idb-border-color--blue {
  border-color: var(--blue-responsible-main);
}

.idb-heading__wrapper.idb-border-color--blue-dark {
  border-color: var(--blue-responsible-darken-2);
}

.idb-heading__wrapper.idb-border-color--gray {
  border-color: var(--neutral-grayMedium);
}

@media (min-width: 480px) {

  .idb-heading__title.idb-sort-title {
    max-width: 80%;
  }
}

@media (min-width: 640px) {

  .idb-heading__title.idb-sort-title {
    max-width: 60%;
  }
}

@media (min-width: 768px) {

  .idb-heading__title.idb-sort-title {
    max-width: 50%;
  }
}

@media (min-width: 1024px) {

  .idb-heading__title.idb-sort-title {
    max-width: 44%;
  }
}

@media (min-width: 1280px) {

  .idb-heading__title.idb-sort-title {
    max-width: 31%;
  }
}

@media (min-width: 2180px) {

  .idb-heading__title.idb-sort-title {
    max-width: 20%;
  }
}

@media (min-width: 480px) {

  ::slotted([slot="title"]) .idb-sort-title {
    max-width: 80%;
  }
}

@media (min-width: 640px) {

  ::slotted([slot="title"]) .idb-sort-title {
    max-width: 60%;
  }
}

@media (min-width: 768px) {

  ::slotted([slot="title"]) .idb-sort-title {
    max-width: 50%;
  }
}

@media (min-width: 1024px) {

  ::slotted([slot="title"]) .idb-sort-title {
    max-width: 44%;
  }
}

@media (min-width: 1280px) {

  ::slotted([slot="title"]) .idb-sort-title {
    max-width: 31%;
  }
}

@media (min-width: 2180px) {

  ::slotted([slot="title"]) .idb-sort-title {
    max-width: 20%;
  }
}
`;